const SimpleWizard = {
	init() {
		this.currentTab = 0;
		this.tabs = document.getElementsByClassName('simple-wizard__fieldset');
		this.prevBtn = document.getElementById('prevBtn');
		this.nextBtn = document.getElementById('nextBtn');
		if (this.tabs != null && this.tabs.length > 0 && this.nextBtn != null) {
			this.showTab();
			this.initEvents();
		}
	},

	initEvents() {
		if (this.prevBtn != null) {
			this.prevBtn.addEventListener('click', (event) => {
				event.preventDefault();
				this.nextPrev(-1);
			});
		}
		this.nextBtn.addEventListener('click', (event) => {
			event.preventDefault();
			this.nextPrev(1);
		});
	},

	showTab() {
		this.tabs[this.currentTab].style.display = 'block';
		// fix the Previous/Next buttons:
		if (this.prevBtn != null) {
			if (this.currentTab === 0) {
				this.prevBtn.style.visibility = 'hidden';
			} else {
				this.prevBtn.style.visibility = 'visible';
			}
			if (this.tabs[this.currentTab].dataset.prevBtnText) {
				this.prevBtn.innerText = this.tabs[this.currentTab].dataset.prevBtnText;
			}
		}
		if (this.tabs[this.currentTab].dataset.nextBtnText) {
			this.nextBtn.innerText = this.tabs[this.currentTab].dataset.nextBtnText;
		}
		if (document.querySelectorAll('.wizard__counter').length > 0) {
			this.tabCounter(this.tabs.length, this.currentTab);
		}
	},

	nextPrev(n) {
		// This function will figure out which tab to display
		// Hide the current tab:
		if (this.currentTab + 1 < this.tabs.length || n === -1) {
			this.tabs[this.currentTab].style.display = 'none';
		}
		// Increase or decrease the current tab by 1:
		this.currentTab += n;
		// if you have reached the end of the form... :
		if (this.currentTab >= this.tabs.length) {
			// reset current tab to last one
			this.currentTab -= 1;
			window.dispatchEvent(new CustomEvent('lightbox-close'));
			return false;
		}
		// Otherwise, display the correct tab:
		this.showTab(this.currentTab);
		return false;
	},

	tabCounter(totalTabs, currentTab) {
		document.querySelector('.wizard__counter').innerText = `${currentTab}/${totalTabs - 1}`;
	},
};

export { SimpleWizard as default };
